import React, { useState } from "react";
import MyMap from "../../Maps/MyMap";
import MapIcon from "../../../assets/icons/mapping.svg2";
import Clusters from "../../Maps/Clusters";
import { AbsoluteLoadingIndicator } from "../FullScreenLoadingIndicator";
import HelpButton from "../../HelpContent/HelpButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const filters = {
  Contacts: true,
  Assets: true,
  Direct: false,
  Indirect: false,
  ExcludeWithLocation: false,
};

export default function ContactsAndAssetsMapWidget() {
  const [loading, setLoading] = useState(false);

  return (
    <div className="h-100 p-3 rounded-3">
      <AbsoluteLoadingIndicator loading={loading} />

      <div className="card-body d-flex flex-column justify-content-between h-100">
        <div className="text-white ">
          <MapIcon width={20} className=" white opacity-50" />
          <Link
            className="btn p-0 text-white"
            to="/assets/maps"
            state={{
              mapFilters: {
                Contacts: true,
                Assets: true,
                Direct: false,
                Indirect: false,
                ExcludeWithLocation: false,
              },
            }}
          >
            <h6 className="m-0 mx-2 small fw-bold">CONTACTS AND ASSETS MAP</h6>
          </Link>
          <HelpButton
            helpKey="widget-contacts-assets-map"
            iconClassName="white"
          />{" "}
          <FontAwesomeIcon
            icon={faGripVertical}
            className="ms-4 opacity-50 widget-header"
          />
        </div>
        <hr className="text-white my-2" />
        <div className="text-black h-100">
          <MyMap mapTypeControl={false}>
            <div className="d-flex justify-content-start text-black">
              <Clusters filters={filters} setLoading={setLoading} />
            </div>
          </MyMap>
        </div>
      </div>
    </div>
  );
}
